import Button from "components/Button";
import * as S from "./styles";

import { ReactComponent as CarIcon } from "assets/car.svg";
import { ReactComponent as HomeIcon } from "assets/home.svg";
import { ReactComponent as LocalPin } from "assets/local-pin.svg";
import { ReactComponent as AgentIcon } from "assets/SidebarIcons/peoplesafeone.svg";

import Close from "assets/close-small.svg";

import { AllMapDetailsSkeleton } from "./skeleton";
import { useManualOccurrence } from "contexts/register/ManualOccurrence";
import { useGlobalMapActions } from "contexts/map";
import { IMapLocationData } from "contexts/map/types";
import { socket } from "hooks/useSocket";
import { fireToast } from "services/sweetAlertConfig";

type Props = {
  onShowRadiusClick: () => void;
  onRequestClose: () => void;
};

export function AllMapDetails({ onShowRadiusClick, onRequestClose }: Props) {
  const { isFetching, occurrenceToEdit, occurrenceType } =
    useManualOccurrence();
  const { handleMapCenterChange, handleMoreDetailClick } =
    useGlobalMapActions();

  const name = occurrenceType === "vehicular" ? "Veicular" : "Patrimonial";
  const icon = occurrenceType === "vehicular" ? <CarIcon /> : <HomeIcon />;

  const policeman =
    occurrenceToEdit.policemen?.[0]?.policeman.user.name ??
    occurrenceToEdit.report?.[0]?.superficialPoliceman?.name;
  const isSuperficialPolicemanOccurrence =
    occurrenceToEdit.report?.[0]?.superficialPoliceman;
  const policemanId =
    occurrenceToEdit.policemen?.[0]?.policeman.id ??
    occurrenceToEdit.report?.[0]?.superficialPoliceman?.id;

  function handleOccurrencePinClick() {
    handleMapCenterChange({
      lat: occurrenceToEdit.lastCoordX,
      lng: occurrenceToEdit.lastCoordY,
    });
  }

  async function fetchPolicemanLocation() {
    if (isSuperficialPolicemanOccurrence) {
      return fireToast(
        "Essa ocorrência está sendo feita por um pronta-resposta avulso fora do aplicativo (sem rastreio de localização)"
      );
    }

    socket.emit("getLocation", policemanId, (location: IMapLocationData) => {
      if (!location) {
        return fireToast("A localização do pronta-resposta não foi encontrada");
      }

      handleMapCenterChange({
        lat: location.coords.lat,
        lng: location.coords.lng,
      });
    });
  }

  if (isFetching) {
    return <AllMapDetailsSkeleton />;
  }

  return (
    <S.Wrapper>
      <S.Body>
        <S.OccurrenceColumn>
          <S.OccurrenceHeader>
            <S.HeaderBody>
              <S.HeaderBodyInfo>
                <S.IconContainer>{icon}</S.IconContainer>
                <S.TextContainer>
                  <h4>Ocorrência {name}</h4>
                  <h4 onClick={handleOccurrencePinClick}>
                    {occurrenceToEdit?.lastCoordX}, {occurrenceToEdit?.lastCoordY}
                  </h4>
                </S.TextContainer>
              </S.HeaderBodyInfo>
              <button onClick={handleOccurrencePinClick}>
                <LocalPin />
              </button>
            </S.HeaderBody>
          </S.OccurrenceHeader>
        </S.OccurrenceColumn>
        <S.Column>
          {!policeman ? (
            <S.EmptyContainer>
              <h3>Ocorrência sem pronta-resposta</h3>
            </S.EmptyContainer>
          ) : (
            <S.OccurrenceHeader>
              <S.HeaderBody>
                <S.HeaderBodyInfo>
                  <S.IconContainer>
                    <AgentIcon />
                  </S.IconContainer>
                  <S.TextContainer>
                    <h4 onClick={fetchPolicemanLocation}>{policeman}</h4>
                  </S.TextContainer>
                </S.HeaderBodyInfo>
                <button onClick={fetchPolicemanLocation}>
                  <LocalPin />
                </button>
              </S.HeaderBody>
            </S.OccurrenceHeader>
          )}
        </S.Column>
      </S.Body>
      <div>
        {isSuperficialPolicemanOccurrence && (
          <S.ManualBadgeContainer>
            <S.ManualBadge>Ocorrência manual</S.ManualBadge>
          </S.ManualBadgeContainer>
        )}

        <S.FooterButtonContainer>
          <Button
            title="Ver dados da ocorrência"
            onClick={() => handleMoreDetailClick(occurrenceToEdit.id)}
          />
          <Button
            title="Exibir raio de busca (cerca)"
            onClick={onShowRadiusClick}
          />
        </S.FooterButtonContainer>
      </div>

      <S.CloseButton type="button" onClick={onRequestClose}>
        <img src={Close} alt="Botão de fechar o pop-up" />
      </S.CloseButton>
    </S.Wrapper>
  );
}
